
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import ExpandIcon from "@/components/utils/ExpandIcon.vue";
import { GetInstructionFile } from '@/components/utils/GetInstructionFile';

import "@/store/modules/forms/form4";
const form4State = namespace("Form4");

import "@/store/modules/forms/form16";
const form16State = namespace("Form16");

import "@/store/modules/forms/form17";
const form17State = namespace("Form17");

@Component({
    components:{
        ExpandIcon
    }
})
export default class OrdersAppRightToAppealPg extends Vue { 

    @Prop({required: true})
    app!: boolean;
    
    @form4State.Action
    public UpdateCurrentNoticeOfApplicationId!: (newCurrentNoticeOfApplicationId: string) => void

    @form16State.Action
    public UpdateCurrentOfferToSettleCostsId!: (newCurrentOfferToSettleCostsId: string) => void
    
    @form17State.Action
    public UpdateCurrentCertificateOfCostsId!: (newCurrentCertificateOfCostsId: string) => void
    
    showOrderInfo = true;
    showSignInfo = false;
    showCostsInfo = false;
    showDirectionsInfo = false;

    public navigateToDraftOrders() {       
        this.$router.push({name: "checklist-orders"})
    }

    public showOrder(show: boolean){
        if (show) {
            this.showOrderInfo = true;
            this.$emit('adjustHeights', 0, "21rem")
        } else {
            this.showOrderInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showSign(show: boolean){
        if (show) {
            this.showSignInfo = true;
            this.$emit('adjustHeights', 1, "21rem");
        } else {
            this.showSignInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }        
    }

    public showCosts(show: boolean){
        if (show) {
            this.showCostsInfo = true;
            this.$emit('adjustHeights', 2, "43rem")
        } else {
            this.showCostsInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

    public showDirections(show: boolean){
        if (show) {
            this.showDirectionsInfo = true;
            this.$emit('adjustHeights', 3, "14rem")
        } else {
            this.showDirectionsInfo = false;
            this.$emit('adjustHeights', 3, "0");
        }
    }

    public startNewForm4Document(){
        this.UpdateCurrentNoticeOfApplicationId(null);
        this.$router.push({name: "start-form4" })
    }

    public startNewForm16Document(){
        this.UpdateCurrentOfferToSettleCostsId(null);
        this.$router.push({name: "start-form16" });
    }

    public startNewForm17Document(){
        this.UpdateCurrentCertificateOfCostsId(null);
        this.$router.push({name: "start-form17" });
    }

    public downloadInstructions(pdf_name){

        GetInstructionFile(pdf_name);
        
    }


}
